<div class="nav-scroller bg-white shadow-sm">
    <nav class="nav nav-underline">
        <a class="nav-link" [routerLink]="['/organization', id, 'informations']" routerLinkActive="active">
            <fa-icon [icon]="icons['faInfo']"></fa-icon> {{'ORGANIZATION.MENU.generalinformations' | translate}}
        </a>
        <a class="nav-link" [routerLink]="['/organization', id, 'schedules']" routerLinkActive="active">
            <fa-icon [icon]="icons['faClock']"></fa-icon> {{'ORGANIZATION.MENU.openingHours' | translate}}
        </a>
        <a class="nav-link" [routerLink]="['/organization', id, 'prices']" routerLinkActive="active">
            <fa-icon [icon]="icons['faMoneyBill']"></fa-icon> {{'ORGANIZATION.MENU.prices' | translate}}
        </a>
        <a class="nav-link" [routerLink]="['/organization', id, 'facilities']" routerLinkActive="active">
            <fa-icon [icon]="icons['faUniversalAccess']"></fa-icon> {{'ORGANIZATION.MENU.facilities' | translate}}
        </a>
        <a class="nav-link" [routerLink]="['/organization', id, 'courses']" routerLinkActive="active"
            *ngIf="organizationType === 1">
            <fa-icon [icon]="icons['faSwimmer']"></fa-icon> {{'ORGANIZATION.MENU.courses' | translate}}
        </a>
        <a class="nav-link" [routerLink]="['/organization', id, 'events']" routerLinkActive="active">
            <fa-icon [icon]="icons['faCalendarAlt']"></fa-icon> Events
        </a>
        <a class="nav-link" [routerLink]="['/organization', id, 'push-notification']" routerLinkActive="active"
            *ngIf="organizationType === 2">
            <fa-icon [icon]="icons['faBell']"></fa-icon> Push Notification
        </a>
        <a class="nav-link" [routerLink]="['/user','counter', id]" routerLinkActive="active">
            {{'ORGANIZATION.counter' | translate}} <fa-icon [icon]="icons['faArrowRight']"></fa-icon>
        </a>
    </nav>
</div>
